import { useQuery } from 'data-fetching-client';
import { GET_FORM_BY_ID } from 'flow-doctor-lib/queries/CrmObjectQueries';
const useFormSubmission = ({
  portalId,
  formId
}, {
  skip
} = {}) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_FORM_BY_ID, {
    variables: {
      portalId,
      formId
    },
    skip
  });
  const dataToReturn = data && data.formById;
  return {
    data: dataToReturn,
    loading,
    error
  };
};
export default useFormSubmission;